import {
  CollapseProps as MantineCollapseProps,
  Collapse as MantineCollapse,
} from '@mantine/core';

export type CollapseProps = MantineCollapseProps;

export const Collapse = MantineCollapse;

Collapse.displayName = 'Collapse';
